import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const WeChatIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148989)">
        <path
          d="M15.9998 32C24.8363 32 31.9998 24.8366 31.9998 16C31.9998 7.16344 24.8363 0 15.9998 0C7.1632 0 -0.000244141 7.16344 -0.000244141 16C-0.000244141 24.8366 7.1632 32 15.9998 32Z"
          fill="#52BE39"
        />
        <path
          d="M20.1022 12.2736C19.2087 9.7168 16.5151 8 13.3999 8C9.53986 8 6.3999 10.6912 6.3999 14C6.43238 15.8332 7.35294 17.5364 8.8687 18.568L8.0423 20.2208C7.94162 20.4174 8.01942 20.6584 8.21606 20.7591C8.3383 20.8217 8.48414 20.8172 8.6023 20.7471L10.7191 19.5368C11.2934 19.7396 11.889 19.8759 12.4943 19.9431C12.7137 19.9684 12.9122 19.811 12.9375 19.5916C12.9428 19.5457 12.9401 19.4993 12.9295 19.4544C12.8461 19.109 12.8026 18.7552 12.7999 18.4C12.7999 15.3128 15.8503 12.8 19.5999 12.8L19.7175 12.8056C19.8475 12.8043 19.9696 12.7432 20.0487 12.64C20.1254 12.534 20.1454 12.3971 20.1022 12.2736Z"
          fill="white"
        />
        <path
          d="M10.7998 10.3984C10.1371 10.3984 9.59985 10.9357 9.59985 11.5984C9.59985 12.2612 10.1371 12.7984 10.7998 12.7984C11.4626 12.7984 11.9998 12.2612 11.9998 11.5984C11.9998 10.9357 11.4626 10.3984 10.7998 10.3984Z"
          fill="#52BE39"
        />
        <path
          d="M15.5999 10.3984C14.9372 10.3984 14.3999 10.9357 14.3999 11.5984C14.3999 12.2612 14.9372 12.7984 15.5999 12.7984C16.2626 12.7984 16.7999 12.2612 16.7999 11.5984C16.7999 10.9357 16.2626 10.3984 15.5999 10.3984Z"
          fill="#52BE39"
        />
        <path
          d="M25.5998 18.4016C25.5998 15.7544 22.9086 13.6016 19.5998 13.6016C16.291 13.6016 13.5999 15.7544 13.5999 18.4016C13.5999 21.0488 16.291 23.2015 19.5998 23.2015C20.2205 23.2013 20.8387 23.1228 21.4398 22.968L23.423 23.9592C23.6205 24.058 23.8609 23.9781 23.9597 23.7805C24.011 23.6782 24.0159 23.5589 23.9734 23.4528L23.4302 22.0928C24.7284 21.3058 25.5437 19.9186 25.5998 18.4016Z"
          fill="white"
        />
        <path
          d="M17.5998 16C17.158 16 16.7998 16.3582 16.7998 16.8C16.7998 17.2418 17.158 17.6 17.5998 17.6C18.0416 17.6 18.3998 17.2418 18.3998 16.8C18.3998 16.3582 18.0416 16 17.5998 16Z"
          fill="#52BE39"
        />
        <path
          d="M21.5998 16C21.158 16 20.7998 16.3582 20.7998 16.8C20.7998 17.2418 21.158 17.6 21.5998 17.6C22.0416 17.6 22.3998 17.2418 22.3998 16.8C22.3998 16.3582 22.0416 16 21.5998 16Z"
          fill="#52BE39"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_148989">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
